
import React, {ReactElement} from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";

import "./c54a-image.scss";

/**
 * The component get from the API only the image it will display
 */
interface C54AImageData {
    image: string;
}


/**
 * The component 54A renders a horizontally centered image in a desktop one column-page layout
 */
class C54AImage extends TemplateComponent<C54AImageData, TemplateComponentProps<C54AImageData>> {

    componentRender(data: C54AImageData): ReactElement<any> {
        return (
            <div className="c54a-image">
                <img src={data.image} alt=""/>
            </div>
        );
    }
}

export default C54AImage;
